import script from "./customDashboardList.vue?vue&type=script&setup=true&lang=js"
export * from "./customDashboardList.vue?vue&type=script&setup=true&lang=js"

import "./customDashboardList.vue?vue&type=style&index=0&id=025bf5fb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025bf5fb"]])

export default __exports__